import React, { useState } from "react";
import axios from "axios";
import { ShieldCheck, X } from "lucide-react";
import { API } from "../../lib/api";
import IdentityVerification from "../IdentityVerification";

/**
 * Paiement direct (décision d'Avi, 30/09/2026) : on paie sans code, mais
 * une promesse, un paiement en plusieurs fois, un don de société ou
 * « J'ai déjà réglé » engagent la fiche du donateur → on lui demande ici le
 * code, envoyé au contact qu'il a lui-même saisi. Une fois confirmé, le lien
 * devient un lien complet (POST /pay/{token}/verify) et l'action demandée
 * reprend toute seule.
 */
export default function IdentityGateDialog({ token, data, onClose, onVerified }) {
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);

  const confirmer = async (verificationToken) => {
    setEnvoi(true);
    setErreur("");
    try {
      await axios.post(`${API}/pay/${token}/verify`, { verification_token: verificationToken });
      await onVerified();
    } catch (e) {
      setErreur(e?.response?.data?.detail || "La vérification n'a pas abouti. Réessayez.");
      setEnvoi(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="identity-gate-title"
      data-testid="identity-gate"
    >
      <div className="w-full max-w-md rounded-t-3xl bg-white p-5 shadow-xl sm:rounded-3xl sm:p-6">
        <div className="mb-3 flex items-start justify-between gap-3">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-50">
              <ShieldCheck className="h-5 w-5 text-emerald-600" aria-hidden="true" />
            </div>
            <div>
              <h2 id="identity-gate-title" className="font-semibold text-chk-ink">
                Confirmez votre identité
              </h2>
              <p className="mt-0.5 text-sm text-chk-ash">
                Pour enregistrer un engagement à votre nom, nous vous envoyons un code.
                Pour payer tout de suite, ce n'est pas nécessaire.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fermer"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-chk-ash hover:bg-stone-100"
            data-testid="identity-gate-close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <IdentityVerification
          organizationId={data?.organization_id}
          email={data?.verify_email || ""}
          phone={data?.verify_phone || ""}
          firstName={data?.donor_first_name || ""}
          onVerified={(tok) => confirmer(tok)}
          disabled={envoi}
          context="donate"
        />
        {erreur && (
          <p className="mt-3 rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700" role="alert">
            {erreur}
          </p>
        )}
      </div>
    </div>
  );
}
